/**
 * Entity type as procurement sees and changes it. The type decides which
 * documents an application must carry, so the server lets procurement change
 * it only before legal has reviewed documents chosen for the old type; these
 * mirror that rule (server/routes/suppliers.js, PUT /:id/entity-type).
 */

export const ENTITY_TYPE_LABELS = {
  private_company: 'Private Company',
  public_company: 'Public Company',
  partnership: 'Partnership',
  foreign_company: 'Foreign Company',
  individual: 'Individual/Sole Proprietor',
  trust: 'Trust',
  other: 'Other',
};

export const ENTITY_TYPE_OPTIONS = Object.entries(ENTITY_TYPE_LABELS)
  .map(([value, label]) => ({ value, label }));

export const ENTITY_TYPE_EDITABLE_STATUSES = ['draft', 'more_info_required', 'submitted', 'under_review', 'pending_procurement'];

export const entityTypeLabel = (value) =>
  ENTITY_TYPE_LABELS[value] || (value ? String(value).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()) : '-');

export const canChangeEntityType = (user, supplier) =>
  ['procurement', 'super_admin'].includes(user?.role)
  && ENTITY_TYPE_EDITABLE_STATUSES.includes(supplier?.status);
